// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3Wc_l","spinner":"Spinner_spinner__3opNn","spin":"Spinner_spin__1xGAB"};